module.exports = __webpack_public_path__ + "img/footer-tagline.22e1fab8.svg";